// Global text-size adjustment for revQ.
// The app is px-heavy (Tailwind arbitrary px + inline styles + styled blocks),
// so a root font-size change would miss most text. Applying `zoom` to <body>
// scales every glyph reliably (and everything mounted under it, including
// body-level overlays). Persisted per browser.
// Persisted per browser. "100%"/Default renders at true 100% (no base rescale).
const KEY = "revq.textscale";
const BASE = 1;
export const TEXT_LEVELS = [90, 100, 110, 120, 130];
export const TEXT_LABELS = { 90: "Small", 100: "Default", 110: "Large", 120: "Larger", 130: "Largest" };

// Older saved values (125, 140) snap to the nearest step.
const nearest = (v) => (Number.isFinite(v) ? TEXT_LEVELS.reduce((a, b) => (Math.abs(b - v) < Math.abs(a - v) ? b : a)) : 100);

export function getTextScale() {
  return nearest(parseInt(localStorage.getItem(KEY) || "100", 10));
}

export function applyTextScale(v) {
  const val = nearest(v);
  localStorage.setItem(KEY, String(val));
  if (typeof document !== "undefined" && document.body) {
    document.body.style.zoom = String((val / 100) * BASE);
  }
  window.dispatchEvent(new CustomEvent("revq:textscale", { detail: val }));
  return val;
}
